import React from 'react';
function Advertising({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" d="M14 3c1.913.167 5.791 1.6 6 6" />
      <path d="M10 18l3-3 .5-.5c1.333-.333 4.6-1.1 5-1.5.4-.4.167-.833 0-1-2.333-2.5-7.1-7.6-7.5-8-.4-.4-.833.167-1 .5l-2 5L4.5 13c-.667.833-1.5 3 .5 5s4.167.833 5 0zM13.5 15L8 9.5" />
      <path d="M10 18l3 3c.333.333 1.2.8 2 0s.333-1.667 0-2l-3-3" />
    </svg>
  );
}

export default Advertising;
